



















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Modal extends Vue {
  @Prop()
  private active = false

  @Prop()
  private readonly title!: string;

  @Prop({ default: 'Close' })
  private readonly buttonText!: string;

  openModal() {
    this.active = true;
  }

  closeModal(): void {
    this.active = false;
  }
}

